<template>
  <div class="home-redirect">
    <div class="loading-container">
      <div class="loading-spinner"></div>
      <p>正在识别您的设备类型...</p>
    </div>
  </div>
</template>

<script>
import { detectDeviceType } from '@/utils/deviceDetector';

export default {
  name: 'HomeRedirect',
  async created() {
    try {
      // 检测设备类型
      const deviceType = detectDeviceType();
      
      // 检查登录状态
      const isLoggedIn = this.checkLoginStatus();
      
      let targetPath;
      
      if (!isLoggedIn) {
        // 未登录状态 - 跳转到对应设备的登录页面
        targetPath = deviceType === 'mobile' ? '/loginmobile' : '/login';
      } else {
        // 已登录状态 - 跳转到对应设备的班级选择页面
        targetPath = deviceType === 'mobile' ? '/mobile' : '/desktop';
      }
      
      // 执行跳转
      this.$router.push(targetPath);
      
    } catch (error) {
      console.error('根目录重定向出错:', error);
      // 出错时默认跳转到PC端登录页面
      this.$router.push('/login');
    }
  },
  methods: {
    /**
     * 检查用户登录状态
     * @returns {boolean} 是否已登录
     */
    checkLoginStatus() {
      try {
        // 检查localStorage中是否存在教师信息和token
        const teacherInfo = localStorage.getItem('teacherInfo');
        const token = localStorage.getItem('token');
        
        if (!teacherInfo || !token) {
          return false;
        }
        
        // 尝试解析教师信息
        const parsedInfo = JSON.parse(teacherInfo);
        // 检查教师信息是否有效且包含必要字段
        return !!(parsedInfo && parsedInfo.id);
        
      } catch (error) {
        console.error('检查登录状态时出错:', error);
        return false;
      }
    }
  }
}
</script>

<style scoped>
.home-redirect {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background: linear-gradient(135deg, #409EFF, #64b5f6);
}

.loading-container {
  text-align: center;
  color: white;
}

.loading-spinner {
  width: 40px;
  height: 40px;
  border: 4px solid rgba(255, 255, 255, 0.3);
  border-radius: 50%;
  border-top-color: white;
  animation: spin 1s ease-in-out infinite;
  margin: 0 auto 20px;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.loading-container p {
  font-size: 16px;
  margin: 0;
}
</style>